<template>
  <nav
    v-show="isNavBarVisible"
    id="navbar-main"
    class="navbar is-fixed-top"
    :class="{ container: rol == 'client', 'basic-navbar': rol == 'client' }"
  >
    <div class="navbar-brand" v-show="rol != 'client'">
      <div class="navbar-item navbar-item-menu-toggle is-hidden-desktop">
        <a href="#/menu/toggle" @click.prevent="menuToggleMobile">
          <b-icon icon="menu" custom-size="default"></b-icon>
        </a>
      </div>
      <a class="navbar-item" href="/">
        <img :src="require(`@/assets/logos/${domain}.png`)" />
      </a>
    </div>

    <a
      v-for="topBarLink in topBarLinks"
      :key="topBarLink.routeName"
      @click="goTo(topBarLink.routeName)"
      class="navbar-item has-divider is-desktop-icon-only"
      :title="topBarLink.label"
    >
      <text-icon-tile :title="topBarLink.label" :icon="topBarLink.icon" />
    </a>
    <div class="navbar-brand is-right">
      <div class="navbar-item navbar-item-menu-toggle is-hidden-desktop">
        <a @click.prevent="menuNavBarToggle">
          <b-icon :icon="menuNavBarToggleIcon" custom-size="default"></b-icon>
        </a>
      </div>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': isMenuNavBarActive }">
      <div class="navbar-end">
        <language-selector />
        <nav-bar-menu class="has-divider has-user-avatar">
          <div class="is-user-name">
            <span>{{ userEmail }}</span>
            <b-icon icon="menu-down" custom-size="default"></b-icon>
          </div>
          <div slot="dropdown" class="navbar-dropdown">
            <account-info-collapsible-list />
            <a
              class="navbar-item"
              @click.prevent="$router.push({ name: 'admin.settings' })"
            >
              <b-icon icon="tune" custom-size="default"></b-icon>
              <span>{{ $t('Ajustes') }}</span>
            </a>
            <a
              class="navbar-item"
              @click.prevent="$router.push({ name: 'admin.configuration' })"
            >
              <b-icon icon="cogs" custom-size="default"></b-icon>
              <span>{{ $t('Configuración') }}</span>
            </a>
            <a class="navbar-item" @click.prevent="logout">
              <b-icon icon="logout" custom-size="default"></b-icon>
              <span>{{ $t('Cerrar sesión') }}</span>
            </a>
          </div>
        </nav-bar-menu>
      </div>
    </div>
  </nav>
</template>

<script>
import NavBarMenu from '@/components/theme/NavBarMenu'
import AccountInfoCollapsibleList from '@/components/common/AccountInfoCollapsibleList'
import TextIconTile from '@/components/admin/dasboard/TextIconTile'
import LanguageSelector from '@/components/common/settings/LanguageSelector'
import { mapState } from 'vuex'
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'

export default {
  name: 'NavBar',
  components: {
    NavBarMenu,
    LanguageSelector,
    TextIconTile,
    AccountInfoCollapsibleList
  },
  data() {
    return {
      isMenuNavBarActive: false,
      topBarLinks: [
        {
          routeName: 'admin.dashboard',
          label: this.$t('Inicio'),
          icon: 'home'
        },
        {
          routeName: 'admin.users.list',
          label: this.$t('Mi Red'),
          icon: 'account-multiple'
        },
        {
          routeName: 'https://cloud.myneofintech.com',
          label: this.$t('Estación de trabajo'),
          icon: 'calendar'
        },
        {
          routeName: 'admin.products',
          label: this.$t('Productos'),
          icon: 'view-grid'
        },
        {
          routeName: 'admin.private_users',
          label: this.$t('Particulares'),
          icon: 'account-group'
        },
        {
          routeName: 'admin.business',
          label: this.$t('Negocios'),
          icon: 'factory'
        },
        {
          routeName: 'admin.accounting',
          label: this.$t('Contabilidad'),
          icon: 'calculator'
        },
        {
          routeName: 'admin.community',
          label: this.$t('Community'),
          icon: 'graphql'
        },
        {
          routeName: 'admin.partners',
          label: this.$t('Partners'),
          icon: 'briefcase-account-outline'
        }
      ]
    }
  },
  computed: {
    domain() {
      return this.$store.state.domain
    },
    menuNavBarToggleIcon() {
      return this.isMenuNavBarActive ? 'close' : 'dots-vertical'
    },
    toggleTooltip() {
      return this.isAsideWideActive ? 'Collapse' : 'Expand'
    },
    updatesUpdateMarkClass() {
      if (this.navBarUpdatesLevel)
        return 'has-update-mark is-update-state-' + this.navBarUpdatesLevel

      return null
    },
    isPlaygroundActive() {
      return this.$route && this.$route.name === 'playground'
    },
    ...mapState('layout', [
      'isNavBarVisible',
      'isNavBarMenusHoverable',
      'isAsideWideActive',
      'navBarUpdatesLevel'
    ]),
    ...mapState('user', [
      'userName',
      'rol',
      'userEmail',
      'subscription',
      'expirationDate'
    ])
  },
  mounted() {
    this.setHtmlClass(this.isNavBarVisible)
  },
  methods: {
    goTo(routeName) {
      if (routeName.includes('https')) {
        window.open(routeName, '_blank')
      } else {
        this.$router.push({ name: routeName })
      }
    },
    menuToggle() {
      this.$jbUtils.toggle(null, true)
    },
    menuToggleMobile() {
      this.$jbUtils.toggleMobile()
    },
    menuNavBarToggle() {
      this.isMenuNavBarActive = !this.isMenuNavBarActive
    },
    updatesShow() {
      this.$jbUtils.updatesShow()
      this.$store.commit('basic', {
        key: 'navBarUpdatesLevel',
        value: null
      })
    },
    goToProfile() {
      if (this.rol == 'client') {
        this.$router.push({ name: 'onBoard.neofintech.profile' })
      } else {
        this.$router.push({ name: 'admin.profile' })
      }
    },
    goToDashboard() {
      if (this.$router) this.$router.push({ name: 'user.dashboard' })
    },
    async logout() {
      let self = this
      await Auth.signOut().then(function() {
        AmplifyEventBus.$emit('authState', 'signedOut')
        document.querySelector('html').classList.remove('is-aside-active')
        this.$jbUtils.htmlRemoveClass('is-aside-active')
        self.$store.commit('user/UNSET_USER')
      })
    },
    setHtmlClass(val) {
      let htmlClass = 'has-navbar-fixed-top'

      if (val) this.$jbUtils.htmlAddClass(htmlClass)
      else this.$jbUtils.htmlRemoveClass(htmlClass)
    }
  },
  watch: {
    isNavBarVisible(newVal) {
      this.setHtmlClass(newVal)
    }
  }
}
</script>

<style scoped>
.basic-navbar {
  padding-left: 0 !important;
}
.navbar * {
  color: #eb548b;
}
</style>
